module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Medium.96982890.otf";